// extracted by mini-css-extract-plugin
export default {"input":"text-input_input__m08B9"};